module.exports = __webpack_public_path__ + "static/ClickedOthers-9772db8a837d924fe8d5b178ec675864.png";